/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React from "react";
import classes from "./cart.module.css";
import { withTranslation } from "react-i18next";
import currencyFormatter from "../../../helper/currencyFormatter";

const CartHeader = (props) => {
  const t = props.t;
  return (
    <header className={classes.cartHeader}>
      <div className={classes.HeaderTitleDiv}>
        <span>{t("TOTAL")}</span>
      </div>
      <div className={classes.headerRightDiv}>
        <div className={classes.priceGroup}>
          <span className={classes.todaysTotalCost}>
            {currencyFormatter(
              (Math.round(props.nowTotal * 100) / 100).toFixed(2),
            )}
          </span>
          <span className={classes.prefixSpan}>{t("TODAY_COST")}</span>
        </div>
        <div className={classes.priceGroup}>
          <span className={classes.monthlyTotalCost}>
            {currencyFormatter(
              (Math.round(props.recTotal * 100) / 100).toFixed(2),
            )}
          </span>
          <span className={classes.prefixSpan}>{t("RECURRING_COST")}</span>
        </div>
      </div>
    </header>
  );
};

export default withTranslation("translations")(CartHeader);
